import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { LanguagesModule } from '@sbd-account-portal/app/layout/common/languages/languages.module';
import { MessagesModule } from '@sbd-account-portal/app/layout/common/messages/messages.module';
import { NotificationsModule } from '@sbd-account-portal/app/layout/common/notifications/notifications.module';
import { QuickChatModule } from '@sbd-account-portal/app/layout/common/quick-chat/quick-chat.module';
import { SearchModule } from '@sbd-account-portal/app/layout/common/search/search.module';
import { ShortcutsModule } from '@sbd-account-portal/app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from '@sbd-account-portal/app/layout/common/user/user.module';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { ModernLayoutComponent } from '@sbd-account-portal/app/layout/layouts/horizontal/modern/modern.component';
import { NgOptimizedImage } from '@angular/common';
import { CIPXPrimaryButtonComponent } from '@sbd-doug-frontend/shared/lib/ui/buttons';

@NgModule({
    declarations: [
        ModernLayoutComponent
    ],
  imports: [
    HttpClientModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    FuseFullscreenModule,
    FuseLoadingBarModule,
    FuseNavigationModule,
    LanguagesModule,
    MessagesModule,
    NotificationsModule,
    QuickChatModule,
    SearchModule,
    ShortcutsModule,
    UserModule,
    SharedModule,
    NgOptimizedImage,
    CIPXPrimaryButtonComponent,
  ],
    exports     : [
        ModernLayoutComponent
    ]
})
export class ModernLayoutModule
{
}
